var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashbordIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 513295"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.52778 6.05555C4.92384 6.05555 6.05556 4.92383 6.05556 3.52778C6.05556 2.13172 4.92384 1 3.52778 1C2.13172 1 1 2.13172 1 3.52778C1 4.92383 2.13172 6.05555 3.52778 6.05555Z",
    stroke: "#5B6B79",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.4721 6.05555C12.8682 6.05555 13.9999 4.92383 13.9999 3.52778C13.9999 2.13172 12.8682 1 11.4721 1C10.0761 1 8.94434 2.13172 8.94434 3.52778C8.94434 4.92383 10.0761 6.05555 11.4721 6.05555Z",
    stroke: "#5B6B79",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M3.52778 14.0009C4.92384 14.0009 6.05556 12.8691 6.05556 11.4731C6.05556 10.077 4.92384 8.94531 3.52778 8.94531C2.13172 8.94531 1 10.077 1 11.4731C1 12.8691 2.13172 14.0009 3.52778 14.0009Z",
    stroke: "#5B6B79",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11.4721 14.0009C12.8682 14.0009 13.9999 12.8691 13.9999 11.4731C13.9999 10.077 12.8682 8.94531 11.4721 8.94531C10.0761 8.94531 8.94434 10.077 8.94434 11.4731C8.94434 12.8691 10.0761 14.0009 11.4721 14.0009Z",
    stroke: "#5B6B79",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashbordIcon);
export default __webpack_public_path__ + "static/media/dashbordIcon.a7732338fc45029a7069c42800322b27.svg";
export { ForwardRef as ReactComponent };